import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import { successToastMessage } from '../../../components/layout/toast-root/toast';
import { useNavigationStack } from '../../../context/NavigationStackContext';
import { Paths } from '../../../shared/paths';
import { AuthPrimaryButton } from '../components/auth-button';
import AuthTextField from '../components/auth-text-field';
import { useStyles } from './ForgotPassword.styles';
import { useForgotPasswordPage } from './useForgotPasswordPage';

export default function ForgotPassword() {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  // const [emailSent, setEmailSent] = useState<boolean>(false);
  const { navigate } = useNavigationStack();
  const { formik } = useForgotPasswordPage(t, () => {
    successToastMessage(t('forgotPassword.emailSentMessage'));
    navigate(Paths.signIn);
  });

  return (
    <div className={classes.forgotPasswordWrapper}>
      <div className={classes.forgotPasswordContentWrapper}>
        {/*{emailSent && <div className={classes.sentIconWrapper}>*/}
        {/*  <MarkEmailIcon/>*/}
        {/*  <Typography variant={"body1"} align={'center'}>*/}
        {/*		{t("forgotPassword.emailSentMessage")}*/}
        {/*  </Typography>*/}
        {/*</div>*/}
        {/*}*/}

        {/*{!emailSent && */}
        <form
          onSubmit={formik.handleSubmit}
          className={classes.forgotPasswordForm}>
          <AuthTextField
            placeholder={t('common.email')}
            fullWidth
            name="email"
            formik={formik}
          />
          <AuthPrimaryButton
            type="submit"
            fullWidth
            className={classes.forgotPasswordSubmitButton}>
            {t('forgotPassword.sendEmail')}
          </AuthPrimaryButton>
        </form>
        {/*}*/}

        <div className={classes.backToLogin}>
          <Link className={classes.backToLoginButton} to={Paths.signIn}>
            {t('signIn.signIn')}
          </Link>
        </div>
      </div>
    </div>
  );
}
